//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  
  
  export class LookupModel {
      static readonly $typeName = 'LookupModel';
      public description: string;
      public key: string;
      public isUniquePerParent?: boolean;
      
  }



// WEBPACK FOOTER //
// ./src/app/common/models/LookupModel.ts